module.exports = __webpack_public_path__ + "static/media/theatre-programme.49ef399b.svg";